// let apiaddress = 'http://18.166.88.113:8003';
let apiaddress = 'https://uatapi01.6bdf52a.com';
switch (process.env.VUE_APP_MODE) {
  case 'uat':
    // apiaddress = 'http://18.166.88.113:8003';
    apiaddress = 'https://uatapi01.6bdf52a.com';
    break;
  case 'production':
    // 优先读 public/config.js（线上可单独替换），缺省用兜底域名
    apiaddress =
      (typeof window !== 'undefined' &&
        window.__APP_CONFIG__ &&
        window.__APP_CONFIG__.apiBase) ||
      'https://api825.hkv2yr.com';
    break;
}

export default apiaddress + '/league/data';
